/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISupplier
 */
export interface APISupplier {
    /**
     * 
     * @type {string}
     * @memberof APISupplier
     */
    readonly self: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplier
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APISupplier
     */
    readonly articles: string;
    /**
     * 
     * @type {Date}
     * @memberof APISupplier
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APISupplier
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APISupplier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplier
     */
    ustId?: string;
}

/**
 * Check if a given object implements the APISupplier interface.
 */
export function instanceOfAPISupplier(value: object): value is APISupplier {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('articles' in value) || value['articles'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APISupplierFromJSON(json: any): APISupplier {
    return APISupplierFromJSONTyped(json, false);
}

export function APISupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contacts': json['contacts'] == null ? undefined : json['contacts'],
        'articles': json['articles'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
    };
}

export function APISupplierToJSON(value?: Omit<APISupplier, 'self'|'articles'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'],
        'name': value['name'],
        'ust_id': value['ustId'],
    };
}

